import { proxyCustomElement, HTMLElement } from '@stencil/core/internal/client';
import { V as VisibilityManager } from './index2.js';
import './index3.js';

const retryUntilResolve = async (func, delay) => {
    try {
        return await func();
    }
    catch (error) {
        await new Promise((resolve) => setTimeout(resolve, delay));
        return retryUntilResolve(func, delay);
    }
};

const RocheAnchor = /*@__PURE__*/ proxyCustomElement(class RocheAnchor extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.retryIntervalMs = 300;
        this.scrollIntoElement = undefined;
    }
    /**
     * Resolves once the the document has rendered
     */
    async ensureVisibility() {
        await customElements.whenDefined('roche-anchor');
        await retryUntilResolve(VisibilityManager.hasDocumentRendered, this.retryIntervalMs);
    }
    componentDidLoad() {
        VisibilityManager.requestVisibility(this.scrollIntoElement, this.element);
    }
    get element() { return this; }
}, [1, "roche-anchor", {
        "scrollIntoElement": [513, "scroll-into-element"],
        "ensureVisibility": [64]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-anchor"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-anchor":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheAnchor);
            }
            break;
    } });
}

export { RocheAnchor as R, defineCustomElement as d };

//# sourceMappingURL=roche-anchor2.js.map